import { createSlice } from '@reduxjs/toolkit';

// initial state
const initialState = {
	users: [],
};

// active account slice
export const allUsersSlice = createSlice({
	name: 'users',
	initialState,
	reducers: {
		setAllUsers: (state, action) => {
			state.users = action.payload;
		},
	},
});

export const {
	setAllUsers,
} = allUsersSlice.actions;

export default allUsersSlice.reducer;
